import React, { useState, Fragment, useEffect } from 'react';
import { Container, Row, Col, Form, Modal, Button, Card, ListGroup, Badge, Spinner } from 'react-bootstrap';
import Footer from 'layout/footer';
import Header from 'layout/header';
import { FaCashRegister, FaCcMastercard, FaCreditCard, FaGoogle, FaHistory, FaPhone, FaPiggyBank, FaWallet } from 'react-icons/fa';
import { loadFromLocalStorage } from 'utils/LocalStorageUtils';
import { saveToLocalStorage } from 'utils/LocalStorageUtils';
import { isEmpty } from 'utils/utils';
import { apiCall } from 'utils/httpClient';
import apiEndPoint from 'utils/apiEndPoint';
import { failedMessage } from 'utils/httpClient';

import useRazorpay from "react-razorpay";
import { successMessage } from 'utils/httpClient';
import { useNavigate } from 'react-router-dom';
const logo = "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Razorpay_logo.svg/1896px-Razorpay_logo.svg.png"
function CheckoutPage({ setOrderCompleateData, setPageShow, selectedDomain, aiMarketing, orderDetail }) {
  const [Razorpay] = useRazorpay();
  const navigate = useNavigate();
  const [domain, setDomain] = useState('');
  const [isloading, setIsloading] = useState(false);
  const [isloadingPage, setIsloadingPage] = useState(false);
  const [isPremium, setIsPremium] = useState(true);
  // const [aiMarketing, setAiMarketing] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [domainDetail, setDomainDetail] = useState({});
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  const basePrice = 10;
  const premiumCharge = 1000;
  const aiMarketingPrice = 5;
  const [userData, setUserData] = useState({});
  useEffect(() => {
    const authData = loadFromLocalStorage("AUTH_DATA");
    if (authData) {
      setUserData(authData.userDetail)
    }
  }, []);

  const calculateTotal = () => {
    const totalPrice = basePrice * 365 + (selectedDomain?.isPremium ? selectedDomain?.inr_price : 0) + (aiMarketing ? aiMarketingPrice * 365 : 0);
    const formattedPrice = totalPrice.toFixed(2);  // "1688.35" as a string
    const priceAsNumber = parseFloat(formattedPrice);  // 1688.35 as a number if needed
    return priceAsNumber;
  };

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  async function handleOpenCheckoutModal() {

    let array = selectedDomain
    array['total_amount'] = calculateTotal()
    array['user_name'] = userData?.user_name
    array['email'] = userData?.email
    array['mobile'] = userData?.mobile
    setDomainDetail(array)
    saveToLocalStorage("DOMAIN_DETAIL", array);
    setShowModal(true)
  }

  const [userPaymentDetail, setUserPaymentDetail] = useState()
  const [paymentDetail, setPaymentDetail] = useState({})


  // useEffect(() => {
  //   getPaymentDetail()
  // }, [])
  // const getPaymentDetail = async () => {
  //   const { data } = await apiCall("post", apiEndPoint.GETPAYMENTDETAILS, { type: 'razorpay' });
  //   if (data.status === 200) {
  //     setUserPaymentDetail(data.data);
  //   } else {
  //     failedMessage(data.message);
  //   }
  // }
  async function orderCompleate(responce) {
    if (!isEmpty(responce.razorpay_signature)) {
      setIsloadingPage(true)
      // let params = {
      //   order_id: orderDetail?.order_id !== undefined ? orderDetail?.order_id : orderDetail?._id,
      //   razorpay_order_id: responce?.razorpay_order_id,
      //   razorpay_payment_id: responce?.razorpay_payment_id,
      // }
      // const { data } = await apiCall("post", apiEndPoint.GETORDERPAYMENTDETAIL, params);
      // if (data.status === 200) {
      //   setPageShow(3)
      //   if (data?.data != undefined && data?.data != '') {
      //     let arr = data.data
      //     setOrderCompleateData(arr)
      //   }
      // }

      let params = {
        razorpay_order_id: responce?.razorpay_order_id,
        razorpay_payment_id: responce?.razorpay_payment_id,
        razorpay_signature: responce?.razorpay_signature,

        order_id: orderDetail?.order_id !== undefined ? orderDetail?.order_id : orderDetail?._id,
        payment_order_id: paymentDetail?.id,
        order_history_id: paymentDetail?.order_history_id,
        // plan_id: selectPlans?._id,
        domain: selectedDomain?.name,
        domain_price: selectedDomain?.inr_price,
        aimarketing_status: aiMarketing,
        total_amount: calculateTotal(),
        plan_type: 'new',
        billing_details: JSON.stringify({ name: userData?.user_name, email: userData?.email, mobile: userData?.mobile, gstin: 'DFB455' })
      }
      // creating a new order
      const { data } = await apiCall("post", apiEndPoint.ORDERPAYMENT, params);
      if (data.status === 200) {
        // successMessage(data.message);
        setPageShow(3)
        if (data?.data != undefined && data?.data != '') {
          let arr = data.data
          setOrderCompleateData(arr)
        }
      } else {
        navigate("/managetemplate");
        failedMessage(data.message)
      }
      successMessage("Your payment has been completed successfully.");
      setIsloadingPage(false)
    } else {
      failedMessage("Your payment is not completed.")
    }
  }

  async function handlePayment(totalAmount = 0) {
    setIsloading(true)
    let params = { amount: totalAmount }
    // creating a new order
    const { data } = await apiCall("post", apiEndPoint.GENRATEPAYMENTORDERID, params);
    if (data.status !== 200) {
      // failedMessage("Server error. Are you online?");
      failedMessage(data?.message);
      return;
    }
    setPaymentDetail(data.data)
    const { amount, id: order_id, currency } = data.data;
    const options = {
      // key: !isEmpty(userPaymentDetail) ? userPaymentDetail?.key_id : "rzp_test_MdReIabisf3EaD", // Enter the Key ID generated from the Dashboard
      key: "rzp_test_MdReIabisf3EaD", // Enter the Key ID generated from the Dashboard
      amount: amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: currency,
      name: 'Digital india app',
      description: "Test Transaction",
      image: "./assets/images/logo.png",
      order_id: order_id, //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
      handler: function (response) {
        if (response) {
          orderCompleate(response)
        }
      },
      prefill: {
        name: userData?.user_name,
        email: userData?.email,
        contact: userData?.mobile,
      },
      readonly: {
        name: userData?.user_name,
        email: userData?.email,
        contact: userData?.mobile,
      },
      // callback_url: 'https://api.mydigitalindia.app:3000/api/payment/paymentStatusUpdate',
      // redirect: true,
      user_id: userData?._id,

      notes: {
        address: "Razorpay Corporate Office",
        razorpay_order_id: "",
        razorpay_payment_id: "",
        razorpay_signature: "",

        order_id: orderDetail?.order_id !== undefined ? orderDetail?.order_id : orderDetail?._id,
        payment_order_id: paymentDetail?.id,
        order_history_id: paymentDetail?.order_history_id,
        // plan_id: selectPlans?._id,
        domain: selectedDomain?.name,
        domain_price: selectedDomain?.inr_price,
        aimarketing_status: aiMarketing,
        total_amount: totalAmount,
        billing_details: JSON.stringify({ name: userData?.user_name, email: userData?.email, mobile: userData?.mobile, gstin: userData?.gstin != undefined && !isEmpty(userData?.gstin) ? userData?.gstin : '' }),
        user_id: userData?._id,
        payment_type: "new"
      },
      theme: {
        color: "#3399cc",
      },
    };
    setIsloading(false)
    const rzp1 = new Razorpay(options);
    rzp1.open();
  }

  return (
    <Fragment>
      <div style={{ position: 'relative' }}>
        {isloadingPage && <div style={{ position: 'absolute', backgroundColor: 'white', height: '100vh', width: '100%', textAlign: 'center', top: 0 }}> <Spinner style={{ marginTop: '17%' }} animation="border" size="lx" role="status" /> </div>
        }
        <div className="services-section mt-5">
          <div className="container text-center">
            <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
              {languageData?.checkoutPage}
            </h3>
            <br />
            <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 800, margin: 'auto', color: '#444' }}>
              {languageData?.thankYouForChoosingMyDigitalIndia}
            </p>
          </div>
        </div>
        <br /><br />
        <Container>
          <div className="p-4" style={{ border: '1px solid #ddd', borderRadius: '12px' }}>
            <Row>
              <Col md={4}>
                <h6>Billing Details :</h6>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control type="text" placeholder="Akhil Nayak"
                      value={userData?.user_name}
                      onChange={e => {
                        setUserData({
                          ...userData,
                          user_name: e.target.value,
                        });
                      }} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile No.</Form.Label>
                    <Form.Control type="text" placeholder="9998887776"
                      value={`${userData?.mobile}`}
                      onChange={e => {
                        setUserData({
                          ...userData,
                          mobile: e.target.value,
                        });
                      }} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" placeholder="akhilnayak@gmail.com"
                      value={userData?.email}
                      onChange={e => {
                        setUserData({
                          ...userData,
                          email: e.target.value,
                        });
                      }} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>GSTIN (Optional)</Form.Label>
                    <Form.Control type="text" placeholder="GSTIN Number"
                      value={userData?.gstin_number != undefined ? userData?.gstin_number : ''}
                      onChange={e => {
                        setUserData({
                          ...userData,
                          gstin_number: e.target.value,
                        });
                      }} />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={1}></Col>
              <Col md={7}>
                <h5 className="mt-4">Summary :</h5>
                <div style={{ paddingTop: '10px' }}>
                  <Row className="mb-2">
                    <Col>Base Price (Yearly):</Col>
                    <Col className="text-end">Rs {basePrice} x 365 days</Col>
                  </Row>
                  <Row className="mb-2" style={{ borderBottom: '1px solid #ff671f', paddingBottom: 10 }}>
                    <Col>Premium Domain :</Col>
                    <Col className="text-end">Rs {selectedDomain?.isPremium ? selectedDomain?.inr_price : 0}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col>Add on</Col>
                  </Row>
                  <Row className="mb-2" style={{ borderBottom: '1px solid #ff671f', paddingBottom: 10 }}>
                    <Col className="text-muted">AI Marketing</Col>
                    <Col className="text-end">{aiMarketing ? `Rs ${aiMarketingPrice} x 365 days` : '-'}</Col>
                  </Row>
                  <br />
                  <Row>
                    <Col><strong>Total</strong></Col>
                    <Col className="text-end"><strong>Rs {calculateTotal()}</strong></Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
          <br />
          <Button
            style={{ borderRadius: 50, width: 'fit-content', fontSize: 14, background: '#ff966a', color: '#000', fontWeight: 500 }}
            size="lg" onClick={() => setPageShow(1)}
          >
            Back
          </Button>
          <Button
            // onClick={handleOpenModal} // Trigger modal on click
            // onClick={handleOpenCheckoutModal} // Trigger modal on click
            onClick={() => handlePayment(calculateTotal())} // Trigger modal on click
            style={{ marginLeft: 20, borderRadius: 50, width: 'fit-content', fontSize: 14, background: '#ff966a', color: '#000', fontWeight: 500 }}
            size="lg"
          >
            Checkout {isloading && <Spinner animation="border" role="status" style={{ width: '20px', height: '20px' }} />}
          </Button>
        </Container>
      </div>
    </Fragment>
  );
}

export default CheckoutPage;
